/**
 * Toast (refino final, 23/09/2026): fundo tinta, raio 14, texto 14/700 em
 * branco, ícone de 20 por tipo, acima da barra de abas. Substitui o toast
 * verde no meio da tela (decisão de 11/09) — a direção aprovada no handoff
 * põe a confirmação embaixo, onde o polegar está, sem cobrir o conteúdo.
 *
 * Só apresenta: quem decide o texto e quanto tempo ele fica é o store de
 * cada área (roteiro, financeiro), como já era.
 */
import { Icon } from './icons';

export type TomDoToast = 'sucesso' | 'aviso' | 'erro';

/** "pendente de sincronização" é aviso, não sucesso: ainda não chegou ao servidor. */
export function tomDoTexto(texto: string): TomDoToast {
  return /pendente/i.test(texto) ? 'aviso' : 'sucesso';
}

export function Toast({
  texto,
  tom = tomDoTexto(texto),
  acao,
  'data-testid': testId,
}: {
  texto: string;
  tom?: TomDoToast;
  acao?: { rotulo: string; onClick: () => void };
  'data-testid'?: string;
}) {
  return (
    <div className={`nv-toast nv-toast--${tom}`} role="status" aria-live="polite" data-testid={testId}>
      <span className="nv-toast__icon" aria-hidden="true">
        {tom === 'sucesso' ? <Icon name="concluir" size={14} /> : tom === 'erro' ? <Icon name="fechar" size={14} /> : '!'}
      </span>
      <span className="nv-toast__texto">{texto}</span>
      {acao && (
        <button type="button" className="nv-toast__acao" onClick={acao.onClick}>
          {acao.rotulo}
        </button>
      )}
    </div>
  );
}
